function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import GridParagraphWithImage from "segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image";
import classnames from "classnames";
import { componentStyles } from "./flexible-cards-grid-mobile-component.scss";
const FlexibleCardsGridMobileComponent = (props)=>{
    const { gridItems, titleSize, textSize, shadowCards, removeShadowOnHover, cancelMobileMarginTop, mobileCenterPadding = "10%" } = props;
    const itemRenderer = (gridItem)=>{
        const { mobileImage, textColor, cardColor, fullParagraph, footer, backgroundImage, mobileBackgroundImage } = gridItem;
        return /*#__PURE__*/ _jsx("div", {
            className: "grid-paragraph-with-image-component-wrapper",
            children: /*#__PURE__*/ _jsx(GridParagraphWithImage, _object_spread_props(_object_spread({}, mobileImage), {
                fullParagraph: fullParagraph,
                width: "100%",
                height: "auto",
                titleSize: titleSize,
                textSize: textSize,
                cardColor: cardColor,
                textColor: textColor,
                shadowCards: shadowCards,
                removeShadowOnHover: removeShadowOnHover,
                footer: footer,
                backgroundImage: mobileBackgroundImage || backgroundImage
            }))
        });
    };
    const carouselProps = {
        items: gridItems,
        itemRenderer,
        defaultIndex: 0,
        infinite: false,
        slidesToShow: 1,
        dots: true,
        centerPadding: mobileCenterPadding,
        focusAfterSwipe: true
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: `jsx-${componentStyles.__hash}` + " " + "flexible-cards-grid-mobile-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: `jsx-${componentStyles.__hash}` + " " + (classnames("carousel-wrapper", {
                    "no-margin": cancelMobileMarginTop
                }) || ""),
                children: /*#__PURE__*/ _jsx(Carousel, _object_spread({}, carouselProps))
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: componentStyles.__hash,
                children: componentStyles
            })
        ]
    });
};
export default FlexibleCardsGridMobileComponent;
